import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { OrderByDirection } from '../../../shared/utils/constant';
import { OrderDraft } from '../../models/eorder';
import { EorderWizardService } from '../../services/eorder-wizard.service';
import { EorderApiService } from '../../services/eorder.api.service';
import { NumberPipe } from '../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-create-order-widget',
	templateUrl: './create-order-widget.component.html',
	styleUrl: './create-order-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,

		MatButtonModule,
		RouterLink,
		MatIconModule,
		LoadingSpinnerComponent,
		NumberPipe
	]
})
export class CreateOrderWidgetComponent implements OnInit {
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	isLoading = true;
	draftCount = 0;
	requiredFields: (keyof OrderDraft)[] = ['orderID'];
	orderDraftSubscription?: Subscription;
	filters = '';
	sortWay = OrderByDirection.DESC;
	sortBy: keyof OrderDraft = 'modificationDate';

	constructor(
		private readonly orderApiService: EorderApiService,
		private readonly eorderWizardService: EorderWizardService,
	) {
		this.eorderWizardService.setOrderId('');
	}

	ngOnInit() {
		this.orderDraftSubscription = this.orderApiService.getDraftOrderCount(
			true
		).subscribe({
			next: response => {
				this.draftCount = response.count;
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('unable to retrieve draft order count', err);
				this.isLoading = false;
				this.eorderWizardService.showError();
			}
		});
	}

	async handleNewOrderWidget() {
		await this.eorderWizardService.actionNewOrder();
	}
}
